import { render, staticRenderFns } from "./BreadcrumbView.vue?vue&type=template&id=a565ac90&scoped=true&lang=pug&"
import script from "./BreadcrumbView.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbView.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbView.vue?vue&type=style&index=0&id=a565ac90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a565ac90",
  null
  
)

export default component.exports